import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Grid from '@mui/material/Grid';

import moment from "moment";

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as UserActions from '../../Store/Actions/User'

import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import MessageView from '../../Components/MessageModal';
import AlertView from '../../Components/AlertModal';
import UserView from './UserModal';
import UserCreateModal from './UserCreateModal';
import UserEditModal from './UserEditModal';

import masterBadgeIcon from '../../Assets/Images/masterBadgeIcon.svg';

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp,

} from '../../Components/Utils';

// export default function Reservation() {
const Users = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	setUser,
	selectedUser,
	retrieveUsers,
	retrieveUser,
	masterUser,
	userRights
} = props;

// Set Overlay obj
const op = React.useRef(null);

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Basic filter fields  and controls
const [basicFilterStatus, setBasicFilterStatus] = React.useState(false);
const [basicFilter, setBasicFilter] = React.useState({});
const [filterValue, setFilterValue] = React.useState("");

// Advanced filter fields and controls
const [advancedFilterStatus, setAdvancedFilterStatus] = React.useState(false);
const [advancedFilter, setAdvancedFilter] = React.useState({});
const [advancedSearch, setAdvancedSearch] = React.useState(false);

// ADVANCED FILTER – USERS
const [advName, setAdvName] = React.useState("");
const [advEmail, setAdvEmail] = React.useState("");
const [advDocument, setAdvDocument] = React.useState("");
const [advPhone, setAdvPhone] = React.useState("");
const [advGroupId, setAdvGroupId] = React.useState(null);
const [advProfileId, setAdvProfileId] = React.useState(null);
const [advMaster, setAdvMaster] = React.useState(null);          // true | false | null
const [advValidated, setAdvValidated] = React.useState(null);    // true | false | null
const [advTwoFactor, setAdvTwoFactor] = React.useState(null);    // true | false | null
const [advCreatedFrom, setAdvCreatedFrom] = React.useState(null);
const [advCreatedTo, setAdvCreatedTo] = React.useState(null);
const [advIncludeDeleted, setAdvIncludeDeleted] = React.useState(false);
const [advStatus, setAdvStatus] = React.useState(null);

const [advAgencyName, setAdvAgencyName] = React.useState("");
const [advTradingName, setAdvTradingName] = React.useState("");
const [advAgencyDocument, setAdvAgencyDocument] = React.useState("");


// STATUS (códigos esperados: [0,1,2,9], ajuste os que você usa)
const [filterByStatus, setFilterByStatus] = React.useState({ code: 1, name: "Ativo" }); 

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);

// Set Fake Data
//var rowsData = ReservationData;
const [rows, setRows] = React.useState([]);
const [totalRecords, setTotalRecords] = React.useState(0);
 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */

 // Ao clicar na linha, abre a modal de EDIÇÃO
 const selectUserAction = (value) => {
   const selected = Array.isArray(value) ? value[0] : value;
   if (!selected) return;
   setSelectedItem(selected);
   setUser(selected);                  // guarda no store para reuso
   setDialog('userEditModal', true);   // abre a modal de edição
 }

// Retrieve reservations
const retrieveItemsList = () => {
  const propsPack = {
    setSaving,
    setAlert,
    setAlertTitle,
    setAlertBody,
    setRows,
    setLoading,
    setTotalRecords,
  };

  const body = buildRequestBody();

  retrieveUsers(body, propsPack);
};
 
  
// Dropdown Values for Basic Search Fields
const [filter, setFilter] = React.useState({ code: "1", field: "name",    name: "Nome do Usuário" });
  
const FilterItems = [
  { code: "1", field: "name",    name: "Nome do Usuário" },
  { code: "2", field: "email",   name: "E-mail" },
  { code: "3", field: "document",name: "CPF" }
];

const [dropdownFilterItems, setDropdownFilterItems] = React.useState(FilterItems);

// Datatable default state
const [lazyState, setlazyState] = React.useState({
  first: 0,
  rows: 25,
  page: 1,
  sortField: "createdAt",
  sortOrder: -1,
  filters: {}
});

// Default columns
// Default columns
const columnsValues = masterUser ? [
'userId',
'agency',
'name',
'contacts',
'profile',
'createdAt',
'status'
] : [
'userId',
'name',
'contacts',
'profile',
'createdAt',
'status'
];
const [visibleColumns, setVisibleColumns] = React.useState(columnsValues);

// Field value format and enrichment (direto do payload da API)
const bodyTemplate = (type, row) => {
  if (!row) return "—";

  // atalhos do payload
  const person  = row.CompanyPerson || {};
  const group   = person.CompanyPersonGroup || {};
  const docs    = Array.isArray(person.CompanyPersonDocuments) ? person.CompanyPersonDocuments : [];
  const profile = row.CompanyPersonUserProfile || {};

  // helpers
  const firstDoc = docs[0]?.formattedValue || null;
  const phoneStr = person.phone ? maskPhone(String(person.phone)) : null;
  const emailStr = row.email || null;

  if (type === "userId") {
    return <div>{row.id}</div>;
  }

  if (type === "agency") {
				
    return (
      <>
		<div>{row?.Company?.companyName || '-'}
		
		{/* Set Master Agency Icon */}
		{row?.Company?.type == 2 &&
		<>
			<svg fill="#814DE5" title="Agência Master" viewBox="0 0 1920 1920" width="15" height="15" style={{}}  xmlns="http://www.w3.org/2000/svg" stroke="#814DE5"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M983.727 5.421 1723.04 353.62c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0ZM757.088 383.322c-176.075 0-319.285 143.323-319.285 319.398 0 176.075 143.21 319.285 319.285 319.285 1.92 0 3.84 0 5.76-.113l58.504 58.503h83.689v116.781h116.781v83.803l91.595 91.482h313.412V1059.05l-350.57-350.682c.114-1.807.114-3.727.114-5.647 0-176.075-143.21-319.398-319.285-319.398Zm0 112.942c113.732 0 206.344 92.724 205.327 216.62l-3.953 37.271 355.426 355.652v153.713h-153.713l-25.412-25.299v-149.986h-116.78v-116.78H868.108l-63.812-63.7-47.209 5.309c-113.732 0-206.344-92.5-206.344-206.344 0-113.732 92.612-206.456 206.344-206.456Zm4.98 124.98c-46.757 0-84.705 37.948-84.705 84.706s37.948 84.706 84.706 84.706c46.757 0 84.706-37.948 84.706-84.706s-37.949-84.706-84.706-84.706Z" fill-rule="evenodd"></path> </g></svg>	
		</>
		}			
		
		</div>
		<div style={{color:"gray"}}>{row?.Company?.tradingName || '-'}</div>
		<div><small style={{color:"gray"}}>{row?.Company?.CompanyDocument?.formattedValue || '-'}</small></div>
		</>	  
    );
  }

  if (type === "name") {
    return (
      <>
        <div>{person.completeName || [person.firstName, person.lastName].filter(Boolean).join(" ") || "—"}</div>
        <div><small style={{color:"gray"}}>{firstDoc || "—"}</small></div>
      </>
    );
  }

  if (type === "contacts") {
    return (
      <>
        <div>{phoneStr || "—"}</div>
        <div><small style={{color:"gray"}}>{emailStr || "—"}</small></div>
      </>
    );
  }

  if (type === "creationDate") {
    return row.createdAt ? moment(row.createdAt).format("DD/MM/YYYY") : "—";
  }

  if (type === "profile") {
    // Badge de perfil + flags úteis

    const badges = [];
    if (group?.name) badges.push(group.name);
	 if (profile?.name) badges.push(profile.name);
    //if (Number(row.authSecureMode) === 2) badges.push("2FA");
    //if (row.validatedAt) badges.push("Validado");

    return <div>{badges.length ? badges.join(" • ") : "—"} {row.master && <> • <img key="master" src={masterBadgeIcon} style={{width:15,height:"auto"}} title="Usuário Master" /></>}</div>;
  }

  if (type === "status") {
    // mapeamento de status (ajuste se seu enum for diferente)
    let activationStatus = "review";
    let activationStatusLabel = "Inativo";

    if (row.status === 1) {
      activationStatus = "ativado";
      activationStatusLabel = "Ativo";
    } else if (row.status === 2) {
      activationStatus = "bloqueado";
      activationStatusLabel = "Bloqueado";
    } else if (row.status === 3) {
      activationStatus = "encerrado";
      activationStatusLabel = "Excluído";
    } else if (row.status === 4) {
      activationStatus = "review";
      activationStatusLabel = "Inativo";
    }

    return <div className={`product-badge status-${activationStatus}`}>{activationStatusLabel}</div>;
  }

  return "—";
};

 
const applyBasicSearch = () => {
	
	// Check if search term is filled and with at least 3 chars
	if (!filterValue) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher o termo a ser buscado pra prosseguir.");	
		return;
	} // end if
	
	if (filterValue.length < 3) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Para prosseguir, você precisa preencher o termo a ser buscado com ao menos 3 caracteres.");	
		return;
	} // end if	
 	
	// Set filter on
	setBasicFilterStatus(true);
	
	// Set advanced filter off
	setAdvancedFilterStatus(false);
	
	// Clean Advanced fields
	setAdvName("");
	setAdvEmail("");
	setAdvDocument("");
	setAdvPhone("");
	setAdvGroupId(null);
	setAdvProfileId(null);
	setAdvMaster(null);
	setAdvValidated(null);
	setAdvTwoFactor(null);
	setAdvCreatedFrom(null);
	setAdvCreatedTo(null);
	setAdvIncludeDeleted(false);
	setAdvStatus(null);

	// Set filter to lazyData
	var currentData = {...lazyState}

	// Set current filter
	currentData.filters = {
		mode:"basic",
		term: filterValue,
		field: filter
	}
	
	// Set LazyState
	setlazyState(currentData);
	
} // end function

const resetSearch = (type)=> {
	
	if (type == "basic") {
		// Set filter on
		setBasicFilterStatus(false);
		
		// Clean Terms
		setFilterValue("");		
	} // end if
	else {
		// Set filter on
		setAdvancedFilterStatus(false);

		setAdvName("");
		setAdvEmail("");
		setAdvDocument("");
		setAdvPhone("");
		setAdvGroupId(null);
		setAdvProfileId(null);
		setAdvMaster(null);
		setAdvValidated(null);
		setAdvTwoFactor(null);
		setAdvCreatedFrom(null);
		setAdvCreatedTo(null);
		setAdvIncludeDeleted(false);
		setAdvStatus(null);
		
	} // end else
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {};
	
	// Set LazyState
	setlazyState(currentData);	
	
} // end fucntion

const applyAdvancedSearch = () => {

	// Check if at least one field is filled
	if (!advName && !advEmail && !advDocument && !advPhone && !advGroupId && !advProfileId && advMaster === null && advValidated === null && advTwoFactor === null && !advCreatedFrom && !advCreatedTo && !advIncludeDeleted && !advStatus) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher ao menos um campo pra prosseguir com a busca.");	
		return;
	} // end if

	// Check if createdAt From and To are filled
	if (advCreatedFrom || advCreatedTo) {
		if (!advCreatedFrom || !advCreatedTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data de criação para prosseguir.");	
			return;
		}
	} // end if
	
	// Check company document if ok
	if (advDocument) {
		if (!validarCPF(advDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CPF / CNPJ informado é inválido. Verifique novamente.");		
			return;
		}
	} // end if	

	 	
	// Set filter on
	setBasicFilterStatus(false);
	
	// Clean Basic Search term
	setFilterValue("");
	
	// Set advanced filter off
	setAdvancedFilterStatus(true);
	
	// Set filter to lazyData
	var currentData = {...lazyState}	
	
	var filters = {};
	filters.mode = "advanced"; 
	filters.name = advName ? advName : null;
	filters.email = advEmail ? advEmail : null;
	filters.document = advDocument ? advDocument : null;
	filters.phone = advPhone ? advPhone : null;
	filters.groupId = advGroupId ? advGroupId : null;
	filters.profileId = advProfileId ? advProfileId : null;
	filters.master = advMaster === null ? null : advMaster ? 1 : 0;
	filters.validated = advValidated === null ? null : advValidated ? 1 : 0;
	filters.twoFactor = advTwoFactor === null ? null : advTwoFactor ? 1 : 0;
	filters.createdAtFrom = advCreatedFrom ? moment(advCreatedFrom).format("YYYY-MM-DD") : null;
	filters.createdAtTo = advCreatedTo ? moment(advCreatedTo).format("YYYY-MM-DD") : null;
	filters.includeDeleted = advIncludeDeleted ? 1 : 0;
	filters.status = filterByStatus ? filterByStatus : null; 
	
	// Apply filter on Data from service 
	let _lazyParams = { ...lazyState, filters:{ fields: filters, mode:"advanced" } };
	setlazyState(_lazyParams);	
	
	// Closes panel
	setAdvancedSearch(!advancedSearch)
	
} // end function
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Set selected columns
const onColumnsChange = (e) => {
	
	let _visibleColumns = [...visibleColumns];

	if (e.checked)
		_visibleColumns.push(e.value);
	else
		_visibleColumns.splice(_visibleColumns.indexOf(e.value), 1);

	setVisibleColumns(_visibleColumns);
}

// Datatable related controls START
const loadLazyData = () => {	
	setLoading(true);
	retrieveItemsList();	
};

// Run after mount component
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@dream4/userData", undefined,true);
	var userData = JSON.parse(result);  

	  // If token dont exist, redirect to onboarding or register
	  if (!userData) {
		  navigate("/home");
		  return;
	  } // end if

  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 

// check if have manageUsers right
React.useEffect(() => {

	  const userRight = userRights.includes("manageUsers") || userRights.includes("all");
	  if (!userRight) {
		  // redirect to admin home
		  navigate("/order");
		  return;
	  }

}, [dialog]); // end useEffect



const onSort = (event) => {
  setlazyState(event);
};

const onFilter = (event) => {
  event['first'] = 0;
  setlazyState(event);
};

const onPage = (event) => {
  setlazyState(event);
};
// Datatable related controls END


// Reacts when lazyState changes
React.useEffect(() => {
	loadLazyData();
}, [lazyState]);

/*React.useEffect(() => {
  if (!loading) return;
  retrieveItemsList();
// eslint-disable-next-line
}, [lazyState]);*/
 

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */


/* -------------------- */ 
/* Helpers */
/* -------------------- */
const buildRequestBody = () => {
  const pagination = {
    first: lazyState.first || 0,
    rows: lazyState.rows || 25,
    sortField: lazyState.sortField || "createdAt",
    sortOrder: lazyState.sortOrder || -1
  };

  // status: se tiver advStatus, usa ele; senão usa o básico
  const statusCode = advStatus?.code ?? [0,1,2];

console.log('[statusCode]--------->]'+JSON.stringify(statusCode, null, 2));

  const statusArray = Array.isArray(statusCode) ? statusCode : [statusCode];

  // ----- BASIC
  if (!advancedFilterStatus) {
    return {
      status: statusArray,
      pagination,
      filters: {
        mode: "basic",
        field: { field: filter?.field || "name" },
        term: (filterValue || "").trim()
      }
    };
  }

  // ----- ADVANCED
  const normGroupId   = Array.isArray(advGroupId)   ? (advGroupId[0]?.code ?? undefined)   : advGroupId || undefined;
  const normProfileId = Array.isArray(advProfileId) ? (advProfileId[0]?.code ?? undefined) : advProfileId || undefined;

  return {
    status: statusArray,
    pagination,
    filters: {
      mode: "advanced",
      fields: {
        name: advName || undefined,
        email: advEmail || undefined,
        document: advDocument || undefined,
        phone: advPhone || undefined,
        groupId: normGroupId,
        profileId: normProfileId,
        master: (advMaster === null ? undefined : !!advMaster),
        validated: (advValidated === null ? undefined : !!advValidated),
        twoFactor: (advTwoFactor === null ? undefined : !!advTwoFactor),
        createdAtFrom: advCreatedFrom ? moment(advCreatedFrom).format("YYYY-MM-DD") : undefined,
        createdAtTo: advCreatedTo ? moment(advCreatedTo).format("YYYY-MM-DD") : undefined,
        includeDeleted: !!advIncludeDeleted
      }
    }
  };
};

  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:"40px",marginTop:"0px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:"64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Usuários</div>
								
								<div style={{flex:3,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
								
									<div style={{padding:"10px",marginRight:"10px",fontSize:"14px"}}>  Filtrar a busca por: </div>
									<div style={{backgroundColor:"#FFF",padding:"10px",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}}> 
										<Dropdown id="filterOption" disabled={saving} value={filter} onChange={(e) => setFilter(e.value)} options={dropdownFilterItems} optionLabel="name" placeholder="Selecione o campo" style={{minWidth:isSpecialDesktop ? "200px" : "230px",textAlign:"left",fontSize:"14px"}} className="w100"></Dropdown>
									</div>
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<div style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
											<InputText id="filterValue" autoComplete="new-password" disabled={saving}  value={filterValue} onChange={(e) => setFilterValue(e.target.value)} placeholder="Termo da busca" tooltip="Digite o termo a ser buscado" tooltipOptions={{position: 'bottom',event: 'focus'}}  style={{borderTopRightRadius:0,borderBottomRightRadius:0,fontSize:"14px"}} />
											<Button labell="Buscar" icon="pi pi-search" style={{borderTopLeftRadius:0,borderBottomLeftRadius:0,height:"47px",fontSize:"14px"}} loading={saving} onClick={()=>{applyBasicSearch()}} />
											 
											{basicFilterStatus &&
											<>
												<Button outlined icon="pi pi-times" style={{height:"47px",fontSize:"14px",marginLeft:"5px"}} loading={saving} tooltip="Selecione para limpar a busca" tooltipOptions={{ showDelay: 500, position: 'bottom',event: 'over'}} onClick={()=>resetSearch("basic")} />
											</>
											}
											
									  </div>							
									</div>									
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<Button className="filterButton" badge={advancedFilterStatus ? <svg viewBox="0 0 24 24" width="12" height="12" style={{position:"absolute",right:"2px",top:"2px"}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCaredrediered" stredoke-width="0"></g><g id="SVGRepo_tredaceredCaredrediered" stredoke-linecap="redound" stredoke-linejoin="redound"></g><g id="SVGRepo_iconCaredrediered"> <path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" fill="#FFF"></path> </g></svg> : ""} badgeClassName={advancedFilterStatus ? "p-badge-secondary" : "hidden"} icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 4C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V13M10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M10 16H6" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="18" cy="17" r="3" stroke="#814DE5" stroke-width="1.5"></circle> <path d="M20.5 19.5L21.5 20.5" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M2 10L7 10M22 10L11 10" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{height:"47px", width:"40px",fontSize:"14px"}} onClick={()=>setAdvancedSearch(!advancedSearch)} tooltip="Selecione para busca avançada" tooltipOptions={{position: 'bottom',event: 'all',showDelay: 500}} /> 
										
										<Button icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9 4V20M15 4V20M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => op.current.toggle(e)}  tooltip="Selecione para escolher as colunas" tooltipOptions={{position: 'bottom',event: 'all',showDelay: 500}} />
										<OverlayPanel ref={op} style={{zIndex:"9999"}}>

										<div className="card flex flex-wrap justify-content-center gap-3" style={{display:"flex",flexDirection:"column",alignItems:"flex-start",justifyContent:"center",gap:"10px",padding:"15px"}}>

											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column1" name="userId" value="userId" onChange={onColumnsChange} disabled={true} checked={visibleColumns.includes('userId')} />
												<label htmlFor="column1" className="ml-2">Nº do Usuário</label>
											</div>
											
											{masterUser &&
											<>
												<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
													<Checkbox inputId="column2" name="agency" value="agency" onChange={onColumnsChange} checked={visibleColumns.includes('agency')} />
													<label htmlFor="column2" className="ml-2">Agência</label>
												</div>
											</>
											}
											
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column3" name="name" value="name" onChange={onColumnsChange} checked={visibleColumns.includes('name')} />
												<label htmlFor="column3" className="ml-2">Nome</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column4" name="contacts" value="contacts" onChange={onColumnsChange} checked={visibleColumns.includes('contacts')} />
												<label htmlFor="column4" className="ml-2">Contatos</label>
											</div>

											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column8" name="profile" value="profile" onChange={onColumnsChange} checked={visibleColumns.includes('profile')} />
												<label htmlFor="column8" className="ml-2">Perfil</label>
											</div>
											
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column6" name="createdAt" value="createdAt" onChange={onColumnsChange} checked={visibleColumns.includes('createdAt')} />
												<label htmlFor="column6" className="ml-2">Criada em</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column9" name="status" value="status" onChange={onColumnsChange} checked={visibleColumns.includes('status')} />
												<label htmlFor="column9" className="ml-2">Status</label>
											</div>											
											
										</div>

										</OverlayPanel> 	

										{/*<Button icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M12 14L12 4M12 4L15 7M12 4L9 7" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>	} outlined severity="secondary" aria-label="Adicionar usuário" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => console.log("EXPORT TO EXCEL")} tooltip="Exportar tabela para EXCEL" tooltipOptions={{position: 'bottom',event: 'all',showDelay: 500}} />*/}										

										{userRights.includes('manageUsers') &&
										<>
											<Button id="newUserButton" icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#814DE5" stroke-width="1.5"></circle> <path d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} outlined severity="secondary" aria-label="Adicionar usuário" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}}  onClick={() => setDialog('userCreateModal', true)} tooltip="Selecione para adicionar um usuário" tooltipOptions={{position: 'bottom',event: 'all',showDelay: 500}} />	
										</>
										}										
										
									</div>
								
								</div>
							
							</div>

							<div className={!advancedSearch ? "advSearchPanel" : "advSearchPanel animate"} style={{width:"100%",backgroundColor:"whitesmoke",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-start",padding:advancedSearch ? "25px" : "0px"}}>
								
								<div style={{textAlign:"left",color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '26px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Busca avançada</div>
								<div style={{textAlign:"left",color: '#000', fontFamily: 'Titillium Web', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',paddingTop:"0px",marginBottom:"35px"}}>Preencha um ou mais campos e faça a busca</div>

								<Grid container spacing={4}>
								
								{masterUser &&
								<>
								
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText value={advAgencyName} onChange={(e) => setAdvName(e.target.value)} id="filterByReservationId" autoComplete="new-password" className="w100" tooltip="Apenas números" tooltipOptions={{ position: 'bottom',event: 'focus' }} />
										<label htmlFor="filterByReservationId">Razão Social</label>
									</span>
								  </Grid>
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText value={advTradingName} onChange={(e) => setAdvAgencyName(e.target.value)} id="filterByAgencyName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyName">Nome Fantasia</label>
									</div>
								  </Grid>

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={advAgencyDocument} onChange={(e) => setAdvAgencyDocument(maskCNPJ(e.target.value))}  onBlur={(e) => setAdvAgencyDocument(maskCNPJ(e.target.value))} id="filterByAgencyDocument" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyDocument">CNPJ</label>
									</div>
								  </Grid>
								  
								  </>
								}
							
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={advName} onChange={(e) => setAdvName(e.target.value)} id="filterByCustomerName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByCustomerName">Nome do Usuário</label>
									</div>
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label" >
										<InputText  value={advDocument} onChange={(e) => setAdvDocument(maskCPF(e.target.value))} onBlur={(e) => setAdvDocument(maskCPF(e.target.value))} id="filterByCustomerDocument" autoComplete="new-password" style={{width:"100%"}} />
										<label htmlFor="filterByCustomerDocument">CPF do Usuário</label>
									</span>		
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={advPhone} onChange={(e) => setAdvPhone(e.target.value)} id="filterByUserName" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByUserName">Telefone</label>
									</span>
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={advEmail} onChange={(e) => setAdvEmail(e.target.value)} id="filterByUserName" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByUserName">Email</label>
									</span>
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<MultiSelect showClear value={advGroupId} onChange={(e) => setAdvGroupId(e.target.value)} options={[{"code":1,name:"Representante Legal"},{"code":2,name:"Funcionário"},{"code":3,name:"Colaborador"}]} optionLabel="name" placeholder="Selecione o grupo da pessoa" className="w100" display="chip"></MultiSelect>
										<label>Grupo da Pessoa</label>
									</div>									
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<MultiSelect showClear value={advProfileId} onChange={(e) => setAdvProfileId(e.target.value)} options={[{"code":1,name:"Gestão"},{"code":2,name:"Administrativo"},{"code":3,name:"Comercial"},{"code":4,name:"Operações"}]} optionLabel="name" placeholder="Selecione o perfil do usuário" className="w100" display="chip"></MultiSelect>
										<label>Perfil do usuário</label>
									</div>									
								  </Grid>								  
								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={advCreatedFrom} onChange={(e) => {setAdvCreatedFrom(e.target.value); setAdvCreatedTo("")}} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criado de </label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={advCreatedTo} minDate={advCreatedFrom} onChange={(e) => setAdvCreatedTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criado até </label>
									</span>										
								  </Grid>
  							  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<Dropdown showClear value={advStatus} onChange={(e) => setAdvStatus(e.target.value)} options={[{"code":1,name:"Ativo"},{"code":0,name:"Inativo"},{"code":2,name:"Bloqueado"}]} optionLabel="name" placeholder="Selecione o Status" className="w100"></Dropdown>
										<label>Status Cadastro</label>
									</div>										
								  </Grid>						 	  

								  <Grid item xs={12} sm={12}>
									<div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"20px"}}> 
									
											<div style={{textAlign:"right",flex:1}}>
												<Button label="Limpar busca" icon="pi pi-trash" severity="danger" text onClick={()=>{resetSearch("advanced");setAdvancedSearch(!advancedSearch)}}  />
											</div>												
											
											<Button rounded outlined className="pT10" label="Fechar" onClick={()=>setAdvancedSearch(!advancedSearch)} />
																				
											<Button rounded className="pT10" label="Buscar" loading={saving} disabled={saving} onClick={()=>{applyAdvancedSearch()}} />		
									</div>
								  </Grid>
								  
								</Grid>							  

							</div>

							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
								
									<DataTable selectionMode="rowClick"

									lazy onPage={onPage}  emptyMessage="Nenhum usuário encontrado."
									onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
									onFilter={onFilter} filters={lazyState.filters} loading={loading} totalRecords={totalRecords}
									
									reorderableColumns reorderableRows stripedRows 
									onSelectionChange={(e) => selectUserAction(e.value)} value={rows} paginator rows={lazyState.rows} rowsPerPageOptions={[10, 25]} tableStyle={{ minWidth: '50rem'}}>
		
										{/* Fixed column */}
										<Column style={{width:"10%"}} field="id" header="Código" body={(data)=>bodyTemplate('userId', data)} />

										{/* Dinamic columns */}
										{visibleColumns.map((col) => { 

										if (col === 'agency' && masterUser) {
											return (
											<Column
												key="agency"
												field="CompanyId"
												header="Agência"
												sortable
												body={(data)=>bodyTemplate('agency', data)}
											/>
											);
										}

										if (col === 'name') {
											return (
											<Column
												key="name"
												field="completeName"
												header="Nome completo"
												sortable
												body={(data)=>bodyTemplate('name', data)}
											/>
											);
										}

										if (col === 'contacts') {
											return (
											<Column
												key="contacts"
												header="Contatos"
												field="contacts"
												body={(data)=>bodyTemplate('contacts', data)}
											/>
											);
										}

										if (col === 'profile') {
											return (
											<Column
												key="profile"
												header="Grupo / Perfil"
												field="profile"
												body={(data)=>bodyTemplate('profile', data)}
											/>
											);
										}

										if (col === 'createdAt') {
											return (
											<Column
												key="createdAt"
												field="createdAt"
												header="Criado em"
												sortable
												body={(data)=>bodyTemplate('creationDate', data)}
											/>
											);
										}

										if (col === 'status') {
											return (
											<Column
												key="status"
												field="status"
												header="Status"
												body={(data)=>bodyTemplate('status', data)}
											/>
											);
										}

										return null;
										})}
										
									</DataTable>
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
		<UserView
			setDialog={setDialog}
			dialog={dialog}
			scrollBlock={false}
		/>		

		<UserCreateModal
			setDialog={setDialog}
			dialog={dialog}
			setAlert={setAlert}
			setAlertTitle={setAlertTitle}
			setAlertBody={setAlertBody}
			selectCompany={masterUser ? true : false}
			isMasterUser={false}
			onReloadDataList={retrieveItemsList}
		/>			

		<UserEditModal
			setDialog={setDialog}
			dialog={dialog}
			setAlert={setAlert}
			setAlertTitle={setAlertTitle}
			setAlertBody={setAlertBody}
			selectCompany={masterUser ? true : false}
			isMasterUser={false}
			onReloadDataList={retrieveItemsList}
			selectedUser={selectedItem}
    		// fallback para a modal encontrar o userId (além do dialog.data)
    		userId={selectedItem?.id}			
		/>			

		<AlertView
			alert={alert}
			setAlert={setAlert}
			alertTitle={alertTitle}
			alertBody={alertBody}	
			scrollBlock={false}				
		/>
		
    </div>
	
	{/* Contac Us Section */}
	<ContactUs />		

	{/* About Us Section */}
	<AboutUs />
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  userRights:store.appReducer.userRights
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...UserActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Users);	


